import Vue from "vue";
import Vuex from "vuex";
import http from "../../service/data-service";

export default {
  state: {
    saques: [],
  },
  getters: {
    saques(state: any) {
      return state.saques;
    },
  },
  mutations: {
    setSaques(state: any, saques: any) {
      state.saques = saques;
    },
  },
  actions: {
    getSaquesByStatus({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/saque/findSaquesByStatus/" + payload)
          .then((result: any) => {
            commit("setSaques", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    getSaques({ commit }: { commit: any }) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/saque/findSaques/")
          .then((result: any) => {
            commit("setSaques", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    aprovarSaque({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {
        http
          .put("/api/v1/saque/update", payload)
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    deleteSaque({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {
        http
          .delete("/api/v1/saque/delete/" + payload)
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
  },
};
